import { Component, Input, OnInit } from '@angular/core';
import * as Parse from 'parse';

@Component({
  selector: 'app-property-progress-tracker',
  templateUrl: './property-progress-tracker.component.html',
  styleUrls: ['./property-progress-tracker.component.scss'],
})
export class PropertyProgressTrackerComponent  implements OnInit {
    @Input() property: Parse.Object = new Parse.Object();
    @Input() detailsPage: boolean = false;
    @Input() loading: boolean = false;

    get analysis() {
        let propertyOfferFlip = this.property.get('offerFlip');
        let propertyOfferFlipHasOfferPrice = false;

        if (propertyOfferFlip !== undefined) {
            propertyOfferFlipHasOfferPrice = propertyOfferFlip.has('offerPrice');
        }

        let propertyOfferFlipIsNaN = isNaN(propertyOfferFlip.get('offerPrice'));

        let propertyOfferRental = this.property.get('offerRental');
        let propertyOfferRentalHasOfferPrice = false;
        if (propertyOfferRental != undefined) propertyOfferRentalHasOfferPrice = propertyOfferRental.has('offerPrice');

        let propertyOfferRentalIsNaN = isNaN(propertyOfferRental.get('offerPrice'));

        return (propertyOfferFlipHasOfferPrice && !propertyOfferFlipIsNaN) || (propertyOfferRentalHasOfferPrice && !propertyOfferRentalIsNaN);
    }

    // property status is any status except Imported or empty
    get offered() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status !== '' && status !== 'lead' && status !== 'imported' && status !== 'accept-unpublished';
    }

    // property status is any status except Imported, Offered or empty
    get active() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status !== '' && status !== 'lead' && status !== 'imported' && status !== 'offered' && status !== 'accept-unpublished';
    }

    get acceptedUnpublished() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status === 'accept-unpublished';
    }

    // property status is any status except Imported, Offered, Accepted, or empty
    get pending() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status !== '' && status !== 'lead' && status !== 'imported' && status !== 'offered' && status !== 'accepted' && status !== 'accept-unpublished';
    }

    // property status is Closed
    get closed() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status === 'closed';
    }

    // property status is Cancelled
    get cancelled() {
        const status: string = this.property.has('status') ? this.property.get('status').toLowerCase() : '';
        return status === 'cancelled';
    }

    constructor() {
    }

    ngOnInit() {

    }
}
